<!--重点用能设备（横柱状，圆弧环状图）-->
<template>
<div class="kee commonborder flex_row">
  <div id="kee_bar1" class="echarts"></div>
  <!-- <div id="kee_pie1" class="echarts"></div> -->
</div>

</template>

<script>
let echarts = require("echarts/lib/echarts");
import api from '@/apis/power/power';
export default {
  data() {
    return {
      number:0,
    };
  },
  methods: {
    //获取列表
    getDevList(){
      api.getImpDevList({
        params: {
          limit: 5,
          page: 1,
        },
      }).then((res) => {
        if (res.code === 10000) {
          let _data = res.data.list
          let _name = []
          let _arrLast = []
          let _arrNow = []
          for(var i in _data){
            _name.push(_data[i].safeFighting.devName)
            let _json = JSON.parse(_data[i].devEnergy.jsonData)
            let _sumL = 0
            let _sumN = 0
            for(var j in _json.lastYear){
              if(!_json.lastYear[j].lossPower){
                _json.lastYear[j].lossPower = 0
              }
              _sumL+=Number(_json.lastYear[j].lossPower)
            }
            _arrLast.push(_sumL)
            for(var k in _json.nowYear){
                if(!_json.nowYear[k].lossPower){
                  _json.nowYear[k].lossPower = 0
                }
              _sumN+=Number(_json.nowYear[k].lossPower)
            }
            _arrNow.push(_sumN)
          }
          console.log(_name,_arrLast,_arrNow);
          this.kee_bar1(_name,_arrLast,_arrNow)
        } else {
          this.$message.error(res.message)
          return;
        }
      })
    },



    kee_bar1(a,b,c){
      // console.log('测试echart动态字体大小',this.$echartsFontSize);
      let kee_bar1 = echarts.init( document.getElementById('kee_bar1') );
      kee_bar1.setOption({
        color:['#00ccff','#f4af1b'],
        tooltip: {
          trigger: 'axis',textStyle:{fontSize: this.$echartsFontSize},
          axisPointer: {
              type: 'shadow'
          },formatter: '{b}<br />去年能耗：{c0} 吨标煤<br />今年能耗：{c1} 吨标煤'
        },
        // legend: {
        //     data: ['去年', '今年'],
        //     right: 10, bottom:'8%',
        //     textStyle: {
        //         color: "#fff",fontSize:this.$echartsFontSize
        //     },
        //     itemWidth: 15,itemHeight: 5,
        // },
        grid: {
          left: "15px", right: "15px", top: "15px", bottom: "15px",
          containLabel: false,
        },
        xAxis: {
          type: "value",show: false,
        },
        yAxis: {
          type: "category", show:false,
          data: a.reverse(),
        },
        series: [
          {
            name: "去年",
            type: "bar",
            barWidth: "22%",
            itemStyle: {
              normal: { 
                label: { show: false},
                barBorderRadius: [0,12,12,0],
              }
            },
            color: {
              type: 'linear',
              x: 0, //右
              y: 0, //下
              x2: 1, //左
              y2: 0, //上
              colorStops: [
                {
                  offset: 0,
                  color: '#1b02f357' // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: '#1b02f7' // 100% 处的颜色
                }
              ]
            },
            data: b.reverse(),
          },
          {
            name: "今年",
            type: "bar",
            barWidth: "22%",barGap:'10%',
            itemStyle: {
              normal: { 
                label: { show: true, 
                  position:[10,'-6px'],formatter: '{b}',lineHeight:'15',color:'#fff',fontSize:this.$echartsFontSize + 2,fontWeight:600,
                  textShadowColor:'#000',textShadowBlur:2, textShadowOffsetX:1, textShadowOffsetY:1
                },
                barBorderRadius: [0,12,12,0],
              }
            },
            color: {
              type: 'linear',
              x: 0, //右
              y: 0, //下
              x2: 1, //左
              y2: 0, //上
              colorStops: [
                {
                  offset: 0,
                  color: '#79f5f71f' // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: '#79f5f7' // 100% 处的颜色
                }
              ]
            },
            data: c.reverse(),
          },
        ],
      })
    },
    //不用
    // kee_pie1(zb){
    //   let kee_pie1 = echarts.init( document.getElementById('kee_pie1') );
    //   kee_pie1.setOption({
    //       color:['#ae74f3','#3d4dae'],
    //       title: [{
    //           text: '重点设备能耗占比',
    //           x: 'center',
    //           top: '18%',
    //           textStyle: {
    //               color: '#ccd0f2',
    //               fontSize:this.$echartsFontSize+2,
    //               fontWeight: '100',
    //           }
    //       }, {
    //           text: zb+'%',
    //           x: 'center',
    //           top: '55%',
    //           textStyle: {
    //               fontSize:this.$echartsFontSize+12,
    //               color: '#fff',
    //               fontWeight: '600',
    //           },
    //       }],
    //       polar: {
    //           radius: ['42%', '50%'],
    //           center: ['50%', '60%'],
    //       },
    //       angleAxis: {
    //           max: 100,
    //           show: false,
    //       },
    //       radiusAxis: {
    //           type: 'category',
    //       },
    //       series: [
    //           {
    //               type: 'bar',
    //               roundCap: true,
    //               barWidth: 60,
    //               showBackground: true,
    //               backgroundStyle: {
    //                   color: 'rgba(255, 255, 255, .2)',
    //               },
    //               data: [zb],
    //               coordinateSystem: 'polar'
    //           }
    //       ] 
    //   })
    // },
  },
  mounted() {
    this.getDevList()//获取列表

  },
};
</script>

<style lang="less" scoped>
.kee{
  #kee_bar1{ height: 100%; width: 100%;}
  #kee_pie1{ height: 100%; width: 35%; position: relative;}
  #kee_pie1::before{ content: ''; position: absolute; top: 8%; left: 8%; width: 84%; height: 84%; background: rgba(3,15,97,.2); border: #555e86 dashed 1px; border-radius: 6px;}
}
</style>